interface ISEOCityObj {
  name: string;
  regionCode: string;
  slug: string;
}
/*
  This is hardcoded SEO data
  It was handpicked by the SEO expert and reflects the most searched for fishing locations in the US.
  In the future this should be stored and fetched from the backend.
  ATTENTION: These links wont work on staging db because the ids are different there.
*/
export const TOP_SEARCHED_CITIES: ISEOCityObj[] = [
  {
    name: 'Key West',
    regionCode: 'FL',
    slug: 'key-west',
  },
  {
    name: 'Galveston',
    regionCode: 'TX',
    slug: 'galveston',
  },
  {
    name: 'Destin',
    regionCode: 'FL',
    slug: 'destin',
  },
  {
    name: 'San Diego',
    regionCode: 'CA',
    slug: 'san-diego',
  },
  {
    name: 'Colorado Springs',
    regionCode: 'CO',
    slug: 'colorado-springs',
  },
  {
    name: 'New Orleans',
    regionCode: 'LA',
    slug: 'new-orleans',
  },
  {
    name: 'San Antonio',
    regionCode: 'TX',
    slug: 'san-antonio',
  },
  {
    name: 'Corpus Christi',
    regionCode: 'TX',
    slug: 'corpus-christi',
  },
  {
    name: 'Seattle',
    regionCode: 'WA',
    slug: 'seattle',
  },
  {
    name: 'Cleveland',
    regionCode: 'OH',
    slug: 'cleveland',
  },
  {
    name: 'Charleston',
    regionCode: 'SC',
    slug: 'charleston',
  },
  {
    name: 'Tampa',
    regionCode: 'FL',
    slug: 'tampa',
  },
  {
    name: 'Myrtle Beach',
    regionCode: 'SC',
    slug: 'myrtle-beach',
  },
  {
    name: 'Fayetteville',
    regionCode: 'NC',
    slug: 'fayetteville',
  },
  {
    name: 'Clearwater',
    regionCode: 'FL',
    slug: 'clearwater',
  },
  {
    name: 'Fort Lauderdale',
    regionCode: 'FL',
    slug: 'fort-lauderdale',
  },
  {
    name: 'Chicago',
    regionCode: 'IL',
    slug: 'chicago',
  },
  {
    name: 'Fort Myers',
    regionCode: 'FL',
    slug: 'fort-myers',
  },
  {
    name: 'Las Vegas',
    regionCode: 'NV',
    slug: 'las-vegas',
  },
  {
    name: 'Los Angeles',
    regionCode: 'CA',
    slug: 'los-angeles',
  },
];
